import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { HEADER, REFERRAL, OPPORTUNITY_STATUSES, EXCLUDE_FROM_AGENT } from '../../../constants';
import { redirectToRoute } from '../../../actions/common.actions';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { referralActions, headerActions, updateStatus, customModalActions } from '../../../actions';
import ContentLoader from '../../common/loaders/ContentLoader';
import { addressConcat, getWeeklyStatusDescription } from 'helpers/utilities';
import StatusBadge from '../../common/Fields/StatusBadge';
import { v4 as uuidv4 } from 'uuid';
import StepInstruction from '../../common/StepInstruction';
import DisplayStatusesInfo from '../../common/DisplayStatusesInfo';

const moment = require('moment');

const headerSettings = {
  type: HEADER.UPDATE_HEADER,
  showHeader: true,
  headerTitle: 'Weekly Status Update',
  hasBackButton: true,
  hasNotificationIcon: true,
  showFooterWithBackButton: true
};

class StatusUpdate extends React.Component {
  static propTypes = {
    fetch: PropTypes.func.isRequired,
    setHeader: PropTypes.func.isRequired,
    opportunity: PropTypes.object,
    redirectToRoute: PropTypes.func.isRequired,
    opportunityType: PropTypes.string.isRequired,
    areasOfInterest: PropTypes.array,
    buyOppStatusList: PropTypes.array,
    sellOppStatusList: PropTypes.array,
    opportunityGroup: PropTypes.string,
    opportunityStatus: PropTypes.string,
    updateStatus: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    contactFirstName: PropTypes.string.isRequired,
    contactLastName: PropTypes.string.isRequired,
    memberKey: PropTypes.string.isRequired,
    isSaveDisabled: PropTypes.bool.isRequired,
    updateCustomModal: PropTypes.func.isRequired,
    hideCustomModal: PropTypes.func.isRequired
  }

  _isMounted = false;

  state = {
    note: '',
    noteCount: 0,
    countMet: false,
    payloadObj: null,
    selectedOppStatus: null,
    opportunity: null,
    triedToSubmit: false,
    step1: { num: 1, bgColor: 'bg-blue-shade', showCheckmark: false },
    step2: { num: 2, bgColor: 'bg-silver', showCheckMark: false }
  }

 confirmCount = () => {
   if (this.state.note.trim().length >= 20) {
     this.setState((state) => ({
       countMet: true,
       triedToSubmit: false,
       step2: { ...state.step2, showCheckMark: true }
     }));
   } else {
     this.setState((state) => ({
       countMet: false,
       step2: { ...state.step2, showCheckMark: false }
     }));
   }
 }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      loginFailed: false
    }, this.confirmCount);
  }

  handleClick = () => {
    this.setState((state) => ({
      step1: { ...state.step1, showCheckmark: true },
      step2: { ...state.step2, bgColor: 'bg-blue-shade' }
    }));
  }

  submitWeeklyStatusUpdate = async () => {
    const routeTo = (this.props.history.length < 2) ? '/dashboard' : 'goback';
    const opportunityStatus = _.get(this.props.opportunity, 'status', null);
    const contactId = _.get(this.props.opportunity, 'contactKey', null);
    const opportunityId = _.get(this.props.opportunity, 'opportunityKey', null);
    const { selectedOppStatus, note } = this.state;
    const guid = uuidv4();
    const noteLength = (note || '').length;
    let reSubmit = false;

    this.setState({ triedToSubmit: true, countMet: noteLength >= 20 });

    if (noteLength < 20) {
      return false;
    }

    const payload = {
      note: {
        noteKey: guid,
        note: this.state.note.trim(),
        isPrivateToAdmins: false
      },
      opportunityStatus: selectedOppStatus && selectedOppStatus !== 'No Status Change' ? this.state.selectedOppStatus : opportunityStatus,
      actionFlags: ['WeeklyUpdate']
    };

    const response = await this.props.updateStatus(contactId, opportunityId, payload, reSubmit, routeTo);
    const newGuid = uuidv4();
    if (response.status === 409 && !reSubmit) {
      reSubmit = true;
      payload.note.noteKey = newGuid;
      await this.props.updateStatus(contactId, opportunityId, payload, reSubmit, routeTo);
    }
  }

  redirectToReferralDetailsPage = () => {
    const contactId = _.get(this.props.opportunity, 'contactKey', null);
    this.props.redirectToRoute(`/referraldetails/${contactId}`);
  }

  componentDidMount = async () => {
    this.props.setHeader(headerSettings);
    this._isMounted = true;
    const contactId = _.get(this.props.match.params, 'contactId', null);
    const opportunityId = _.get(this.props.match.params, 'opportunityId', null);
    this.fetchRequest = await this.props.fetch(contactId, opportunityId);
    this._isMounted && this.setState((state, props) => ({
      opportunity: props.opportunity
    }));
  }

  componentDidUpdate = async (prevProps) => {
    if (prevProps.match.params.opportunityId !== this.props.match.params.opportunityId) {
      this.props.redirectToRoute(`/statusupdates/${this.props.match.params.contactId}/${this.props.match.params.opportunityId}`);
      window.location.reload();
    }
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  getStatusesByOppStatus = (statuses = [], oppType, currOppStatus, opportunityGroup) => {
    const isBuyer = oppType === 'buying';
    const mutuallyAcceptedIndex = _.indexOf(statuses, REFERRAL.MUTUALLY_ACCEPTED, true);
    const currOppStatusIndex = _.indexOf(statuses, currOppStatus, true);
    const preListIndex = _.indexOf(statuses, REFERRAL.PRE_LIST, true);
    const isAfterMutuallyAccepted = currOppStatusIndex >= mutuallyAcceptedIndex;
    const isAfterPreList = currOppStatusIndex >= preListIndex;
    const isNurture = opportunityGroup.toUpperCase() === 'NURTURE';
    const isFallout = opportunityGroup.toUpperCase() === 'FALLOUT';
    const isContingentOnSale = currOppStatus.toUpperCase() === 'CONTINGENT ON SALE';

    if (isContingentOnSale) {
      return OPPORTUNITY_STATUSES.SELLER_STATUS_CONTINGENT_ON_SALE;
    }

    // Covering Status based on Group
    if (isNurture) {
      return isBuyer ? OPPORTUNITY_STATUSES.BUYER_STATUSES_NURTURE : OPPORTUNITY_STATUSES.SELLER_STATUSES_NURTURE;
    }

    if (isFallout) {
      return isBuyer ? OPPORTUNITY_STATUSES.BUYER_STATUSES_FALLOUT : OPPORTUNITY_STATUSES.SELLER_STATUSES_FALLOUT;
    }

    // Covering status for buyer
    if (isBuyer) {
      return !isAfterMutuallyAccepted ? OPPORTUNITY_STATUSES.BUYER_STATUSES_BEFORE_MUTUALLY_ACCEPTED : OPPORTUNITY_STATUSES.BUYER_STATUSES_AFTER_MUTUALLY_ACCEPTED;
    }

    // Covering status for seller
    if (!isBuyer) {
      return !isAfterPreList ? OPPORTUNITY_STATUSES.SELLER_STATUSES_BEFORE_PRE_LIST : OPPORTUNITY_STATUSES.SELLER_STATUSES_AFTER_PRE_LIST;
    }

    // All other cases including 'No Status' - Assuming these are either before mutually accepted or pre list.
    return isBuyer ? OPPORTUNITY_STATUSES.BUYER_STATUSES_BEFORE_MUTUALLY_ACCEPTED : OPPORTUNITY_STATUSES.SELLER_STATUSES_BEFORE_PRE_LIST;
  // }
  }

  fetchLastNoteTimeEnteredByAgent = (memberKey) => {
    const oppNotes = _.get(this.props.opportunity, 'notes', []);
    const lastNoteEnteredByAgent = oppNotes.find(oppNote => _.get(oppNote, 'addedByMember', '') === memberKey);
    return _.get(lastNoteEnteredByAgent, 'timestampEntered', '');
  }

  handleCancelBtn = (history) => {
    if (history.length < 2) {
      history.push('/dashboard');
    } else {
      history.goBack();
    }
  }

  displayStatusInfo = (statusList) => {
    const body = statusList.map((status, index) => <DisplayStatusesInfo key={index} name={status} description={getWeeklyStatusDescription(status)} />);
    this.props.updateCustomModal(true, 'List of Statuses', body, null, this.props.hideCustomModal, this.props.hideCustomModal, true, 'lg', null, 'Close', null, 'status-info-modal');
  }

  render () {
    const { areasOfInterest, opportunity, buyOppStatusList, sellOppStatusList, opportunityGroup, opportunityStatus, memberKey, isSaveDisabled } = this.props;
    const { note, step1, step2 } = this.state;

    const disableStatusSelection = _.includes(EXCLUDE_FROM_AGENT, opportunityStatus);
    const opportunityType = this.props.opportunityType === 'Buyer' ? 'buying' : 'selling';
    const profileFullAddress = _.get(opportunity, 'contactProperty.property.address', null);
    const profileSteetAddress = _.get(opportunity, 'contactProperty.property.address.address1', null);
    const ProfileCityStateZip = (profileFullAddress == null) ? areasOfInterest.slice(0, 2).map((address, index) => address.value + (areasOfInterest.length > 1 ? (index !== 1 ? '; ' : '') : '')) : addressConcat(profileFullAddress || {});
    const contactAddress = addressConcat(_.get(opportunity, 'contactProperty.property.addressproperty.address', {}));
    const lineOneAddress = profileSteetAddress;
    let lineTwoAddress = ProfileCityStateZip;

    const oppStatusList = this.props.opportunityType === 'Buyer' ? this.getStatusesByOppStatus(buyOppStatusList, opportunityType, opportunityStatus, opportunityGroup) : this.getStatusesByOppStatus(sellOppStatusList, opportunityType, opportunityStatus, opportunityGroup) || [];

    if ((this.props.opportunityType === 'Seller') && (profileFullAddress == null)) {
      lineTwoAddress = contactAddress;
    }

    const lastNoteTimeStampEntered = this.fetchLastNoteTimeEnteredByAgent(memberKey);
    const checkMark = <span>&#10003;</span>;

    if (!this.props.contactFirstName) {
      return <ContentLoader isLoading />;
    }
    return (
      <React.Fragment>
        <section className='page-content'>
          <div className='update-status-container'>
            <div onClick={() => this.redirectToReferralDetailsPage()}>
              <div className='text-statusupdate-name status-update-name'>
                {`${this.props.contactFirstName} ${this.props.contactLastName}`}
              </div>
              <div className='property-address d-flex'>
                <div><span className={`lead-type-badge lead-${opportunityType}`} /></div>
                <div className='lead-type-text'>{opportunityType.toUpperCase()}</div>
                <div className='complete-address'>{lineOneAddress} {lineTwoAddress}</div>
              </div>
            </div>
            <div className='status-update-container' onClick={this.redirectToWeeklyStatusUpdate}>
              <div className='opp-group-badge' >
                <StatusBadge statusGroup={opportunityGroup} />
              </div>
              <div className='status-text-container'>
                <div className='status-label-text'> {opportunityStatus}</div>
              </div>
            </div>
            <div className='status-form-wrapper'>
              <div className='status-note-container'>
                <StepInstruction badgeDisplay={(step1.showCheckmark || disableStatusSelection) ? checkMark : step1.num} bgcolor={step1.bgColor} />
                <div className='status-info'>
                  <span className='status-label-text bold-label-text'>New Status </span>
                  {
                    !disableStatusSelection && <i className={'material-icons material-icons-info description-icon'} onClick={() => this.displayStatusInfo(oppStatusList)} />
                  }
                </div>
                <div className='select-status-custom'>
                  <select className='opp-status-select'
                    name='selectedOppStatus'
                    value={this.state.selectedOppStatus || opportunityStatus} onChange={this.handleChange}
                    disabled={disableStatusSelection}
                  >
                    <option value='No Status Change'>No Status Change</option>
                    {oppStatusList.map((status, index) => {
                      return <option key={'opp-status-option-' + index} value={status}>{status}</option>;
                    })}
                  </select>
                </div>
                <StepInstruction badgeDisplay={step2.showCheckMark ? checkMark : step2.num} bgcolor={disableStatusSelection ? 'bg-blue-shade' : step2.bgColor} />
                <div className='note-label'>
                  <div className='status-label-text bold-label-text float-left'>Add Notes </div>
                  {
                    !this.state.countMet && this.state.triedToSubmit && <div className='sub-label-text'> *Please enter at least 20 characters</div>
                  }
                </div>
                <textarea
                  className='status-updates-notes'
                  name='note'
                  placeholder='Please provide a brief update of how you are nurturing this lead.'
                  rows='6'
                  onChange={this.handleChange}
                  onClick={this.handleClick}
                  value={note}
                  maxLength='1000'
                />
                <div>
                  { lastNoteTimeStampEntered &&
                    <div className='sub-label-text float-left'>
                      Last note entered: {moment(lastNoteTimeStampEntered).format('MM/DD/YYYY hh:mm a')}
                    </div>
                  }
                  <div className='text-characters-count'>
                    {`(${note.trim().length}/1000)`}
                  </div>
                </div>
                <div className='status-label-text note-label'>
                  <span className='bold-label-text'>Attention: </span>{REFERRAL.NOTE_DISCLAMIER}

                </div>

                <div className='bottom-button-wrapper status-update-buttons'>
                  <div className='status-buttons' >
                    <button className='login-back-btn' type='reset' onClick={() => this.handleCancelBtn(this.props.history)}>
                      Cancel
                    </button>
                  </div>
                  <div className='status-buttons  push'>
                    <button
                      onClick={this.submitWeeklyStatusUpdate}
                      disabled={isSaveDisabled}
                      className='login-primary-button' type='button'>
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { referrals, contacts, userprofile } = state;
  const opportunity = _.get(referrals, 'activeOpportunity', {});
  const activeContact = contacts;
  const memberKey = _.get(userprofile, 'memberKey', '');

  return {
    opportunity,
    contactFirstName: _.get(activeContact, 'firstName', ''),
    contactLastName: _.get(activeContact, 'lastName', ''),
    opportunityType: _.get(opportunity, 'type', ''),
    areasOfInterest: _.get(opportunity, 'areasOfInterest', []),
    buyOppStatusList: _.get(referrals, 'buyOppStatusList', []),
    sellOppStatusList: _.get(referrals, 'sellOppStatusList', []),
    opportunityGroup: _.get(opportunity, 'group', ''),
    opportunityStatus: _.get(opportunity, 'status', 'No Status'),
    isSaveDisabled: _.get(referrals, 'fetchingOpportunity', false),
    memberKey
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetch: bindActionCreators(referralActions.fetchOpportunity, dispatch),
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  redirectToRoute: bindActionCreators(redirectToRoute, dispatch),
  updateStatus: bindActionCreators(updateStatus, dispatch),
  updateCustomModal: bindActionCreators(customModalActions.updateCustomModal, dispatch),
  hideCustomModal: bindActionCreators(customModalActions.hideCustomModal, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StatusUpdate));
